import { queryAdmBonusAgreements } from "@/graphql/schemas/revenue/queries/queryAdmBonusAgreements"
import { queryAdmStatsByCustomer } from "@/graphql/schemas/revenue/queries/queryAdmStatsByCustomer"
import { queryOrdersCountAndNetInvoiceSumByAdm } from "@/graphql/schemas/revenue/queries/queryOrdersCountAndNetInvoiceSumByAdm"

import { queryAdmRevenueStatsComparison } from "./queries/queryAdmRevenueStatsComparison"
import { queryAdmRevenueStatsProjection } from "./queries/queryAdmRevenueStatsProjection"
import { queryAdmRevenueTargetByArticleMainGroup } from "./queries/queryAdmRevenueTargetByArticleMainGroup"
import { queryAdmStatsByCustomerRanking } from "./queries/queryAdmStatsByCustomerRanking"
import { queryAdmVolumeOverview } from "./queries/queryAdmVolumeOverview"
import { queryAdmVolumeStats } from "./queries/queryAdmVolumeStats"
import { queryAdmYearRevenueOverview } from "./queries/queryAdmYearRevenueOverview"
import { queryRevenueByArticleMainGroup } from "./queries/queryRevenueByArticleMainGroup"
import { typeRevenueStats } from "./revenueStats"

const revenueSchema = {
  types: [typeRevenueStats],
  resolvers: {
    Query: {
      ...queryAdmBonusAgreements,
      ...queryAdmStatsByCustomer,
      ...queryOrdersCountAndNetInvoiceSumByAdm,
      ...queryAdmRevenueStatsComparison,
      ...queryAdmRevenueStatsProjection,
      ...queryAdmYearRevenueOverview,
      ...queryAdmRevenueTargetByArticleMainGroup,
      ...queryRevenueByArticleMainGroup,
      ...queryAdmVolumeOverview,
      ...queryAdmVolumeStats,
      ...queryAdmStatsByCustomerRanking,
    },
    Mutation: {},
  },
}

export default revenueSchema
